export const ADD_TASK="ADD_TASK";
export const REMOVE_TASK="REMOVE_TASK";
export const UPDATE_TASK="UPDATE_TASK";
export const REMOVE_COMPLETED_TASK="REMOVE_COMPLETED_TASK";
export const CHANGE_FILTER="CHANGE_FILTER";
export const CHANGE_TASKS_VISIBLE="CHANGE_TASKS_VISIBLE";
export const REORDER_TASK="REORDER_TASK";